// extracted by mini-css-extract-plugin
export var body = "_m5-0";
export var sectionHeader = "_m5-4";
export var shortcutColumns = "_m5-2";
export var shortcutList = "_m5-1";
export var shortcutSection = "_m5-3";